import { render, staticRenderFns } from "./ChildGroupFeeExcel.vue?vue&type=template&id=fb2121c8&scoped=true&"
import script from "./ChildGroupFeeExcel.vue?vue&type=script&lang=js&"
export * from "./ChildGroupFeeExcel.vue?vue&type=script&lang=js&"
import style0 from "./ChildGroupFeeExcel.vue?vue&type=style&index=0&id=fb2121c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2121c8",
  null
  
)

export default component.exports